<template>
  <div class="bottom">
    <Loading type="form" :isLoading="isLoading" />
    <b-container class="form-container" align-content="center">
      <b-row class="primary-row">
        <b-col class="form-group custom-col row">
          <button
            aria-label="Print label"
            class="printButton btn"
            @click="printLabel"
          >
            Print
          </button>
          <button
            aria-label="Reload label"
            v-if="labelLoadFailed"
            class="printButton btn"
            @click="getLabel"
          >
            Reload Label
          </button>
          <iframe
            ref="frame"
            tabindex="-1"
            title="Broadband Label"
            id="broadband-label"
            style="
              height: 960px;
              width: 100%;
              border: none;
              background: #f3f4f6;
            "
            :src="iframeHTML"
            @load="adjustHeight"
            scrolling="no"
          ></iframe>
        </b-col>
        <b-col class="form-group custom-col">
          <b-row cols="3">
            <b-col>
              <b-form-radio v-model="selectedLang" name="English" value="EN"
                >English</b-form-radio
              >
            </b-col>
            <b-col>
              <b-form-radio v-model="selectedLang" name="Spanish" value="ES"
                >Spanish</b-form-radio
              >
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <form @submit.prevent="submitForm">
              <label>Phone<span class="required"></span></label>
              <b-row
                class="no-gutters"
                style="min-width: 275px; max-width: 275px"
              >
                <b-form-input
                  type="text"
                  v-model="phoneNumber"
                  id="phone-number"
                  aria-label="Enter phone number"
                  placeholder="(000)000-0000"
                  :class="{
                    'is-invalid':
                      formSubmitted && !isPhoneNumberValid && phoneNumber,
                  }"
                />
                <div
                  v-if="!isPhoneNumberValid && phoneNumber"
                  class="invalid-feedback"
                >
                  Please enter a valid phone number.
                </div>
                <div v-else style="min-height: 62px">
                  <br />
                </div>
              </b-row>
              <label>Email<span class="required"></span></label>
              <b-row
                class="no-gutters"
                style="min-width: 275px; max-width: 275px"
              >
                <b-form-input
                  type="text"
                  id="email"
                  aria-label="Enter email"
                  v-model="email"
                  placeholder="youremail@example.com"
                  :class="{
                    'is-invalid': formSubmitted && !isEmailValid && email,
                  }"
                />
                <div v-if="!isEmailValid && email" class="invalid-feedback">
                  Please enter a valid email address.
                </div>
                <div v-else style="min-height: 62px">
                  <br />
                </div>
              </b-row>
              <br />
              <b-row class="no-gutters">
                <BottomButton
                  :loading="false"
                  :text="'Submit'"
                  type="submit"
                  ref="submit"
                />
              </b-row>
            </form>
          </b-row>
        </b-col>
      </b-row>
      <md-dialog-confirm  
        :md-active.sync="showSubmitModal"
        md-title="Delivery Method Confirmation"
        :md-content="`<strong>You would like to send this to the following?</strong><br><br>${phoneNumber ? `<strong>Phone:</strong> ${phoneNumber}<br>` : ''}${email ? `<strong>Email:</strong> ${email}` : ''}`"
        md-confirm-text="Submit"
        md-cancel-text="Cancel"
        @md-cancel="() => {}"
        @md-confirm="onConfirmSubmit"
      />
    </b-container>
  </div>
</template>

<script>
import { LoadingStore } from "@/store/LoadingStore.js";
import BottomButton from "./BottomButton";
import Loading from "@/components/Loading.vue";
import axios from "axios";
export default {
  name: "BroadbandLabel",
  components: {
    Loading,
    BottomButton,
  },
  props: {
    taxgeocode: String,
    fcc_label_id: String,
    comm_eff_dt: String,
    acct_type: String,
    sub_type: String,
    fcc_form_selections: Object,
  },
  data() {
    return {
      loaded: false,
      phoneNumber: "",
      email: "",
      selectedLang: "EN",
      formSubmitted: false,
      showSubmitModal: false,
      labelData: {},
      store: LoadingStore(),
      isLoading: true,
      labelHTML: "",
      iframeHTML: "",
      labelLoadFailed: false,
    };
  },
  computed: {
    isPhoneNumberValid() {
      const phoneNumberPattern =
        /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      return phoneNumberPattern.test(this.phoneNumber);
    },
    isEmailValid() {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailPattern.test(this.email);
    },
    isFormValid() {
      return (
        (this.isPhoneNumberValid && this.isEmailValid) ||
        (this.isPhoneNumberValid && !this.email) ||
        (!this.phoneNumber && this.isEmailValid)
      );
    },
  },

  created() {},
  watch: {
    selectedLang: {
      handler: function () {
        this.getLabel();
        this.showLoading();
      },
      immediate: true,
    },
  },
  mounted() {
    this.showLoading();
  },
  methods: {
    showLoading(isLoading = true) {
      this.store.type = "form";
      this.store.isLoading = isLoading;
      this.isLoading = isLoading;
    },
    generateAcctTypeSubTypeString(){
      if (this.acct_type && this.sub_type) {
        return `&acctype=${this.acct_type}&accsubtype=${this.sub_type}`
      }
      return ``
    },
    getLabel() {
      let lang = "";
      if (this.selectedLang == "ES") {
        lang = `/es-us`;
      }
      const types = this.generateAcctTypeSubTypeString()
      axios
        .get(
          `${process.env.VUE_APP_FCC_HOST}${lang}/labels/shared/nutrition/${this.fcc_label_id}?taxationgeocode=${this.taxgeocode}${types}`
        )
        .then((resp) => {
          if (resp && resp.data) {
            this.setLabel(resp.data);
          } else {
            this.setLabel("");
            this.labelLoadFailed = true;
            this.$noty.error(
              "Error getting label, please try reloading the label.",
              { layout: "top" }
            );
          }
        })
        .catch((error) => {
          this.setLabel("");
          this.labelLoadFailed = true;
          this.$noty.error(
            "Error getting label, please try reloading the label.",
            { layout: "top" }
          );
          console.log(error);
        });
    },
    setLabel(html) {
      if (html === "") {
        this.labelLoadFailed = true;
      } else {
        this.labelLoadFailed = false;
      }

      // Set the HTML string to keep original data.
      this.labelHTML = html;

      // Create blob for iframe injection
      const blob = new Blob([html], { type: "text/html" });
      const url = URL.createObjectURL(blob);
      this.iframeHTML = url;

      // Complete loading
      this.showLoading(false);
    },
    printLabel() {
      const frame = window.frames["broadband-label"];
      if (frame && frame.contentWindow) {
        frame.contentWindow.print();
      } else {
        console.error(
          'Frame "broadband-label" does not exist or does not have a contentWindow property'
        );
      }
    },
    submitForm() {
      // Check if form is valid  (phone and email)
      if (this.isFormValid) {
        this.showSubmitModal = true;
      } else {
        this.$noty.error(
          "Please use a valid phone number, valid email address, or both.",
          { layout: "top" }
        );
      }
    },
    adjustHeight() {
      this.$nextTick(() => {
        const frame = this.$refs.frame;
        frame.style.height = `${frame.contentWindow.document.body.scrollHeight}px`;
      });
    },
    onConfirmSubmit() {
      const formData = {
        taxgeocode: this.taxgeocode,
        fcc_id: this.fcc_label_id,
        comm_eff_dt: this.comm_eff_dt,
        email_address: this.email,
        phone: this.phoneNumber,
        lang: this.selectedLang,
        market_type: this.fcc_form_selections.market_type,
        plan_type: this.fcc_form_selections.plan_type,
        plan_name: this.fcc_form_selections.plan_name,
        cust_dt: this.fcc_form_selections.start_date,
        address_ln_1: this.fcc_form_selections.address_ln_1,
        city: this.fcc_form_selections.city,
        state: this.fcc_form_selections.state,
        zip: this.fcc_form_selections.zip,
      };
      axios
        .post("/fcc/send-broadband-label", formData)
        .then(() => {
            this.$noty.success(
              "Broadband label sent successfully.",
              { layout: "top" }
            );
        })
        .catch((error) => {
          console.log(error.response.data.message);
          let errMessage = "Error generating broadband label, try again later."
          if (error.response.data.message) {
            errMessage = error.response.data.message; 
          }
          this.$noty.error(
            errMessage,
            { layout: "top" }
          );
        });
      this.formSubmitted = true;
      this.showSubmitModal = false;
    },
  },
};
</script>

<style>
.md-dialog-title {
  background: #006ffa;
  color: white;
  padding-bottom: 10px;
}
.md-button-content {
  color: #006ffa;
}
.md-dialog-container {
  background: white;
}
.primary-row {
  justify-content: center;
  flex-wrap: wrap-reverse;
}
.custom-col {
  max-width: 350px;
}
.row {
  justify-content: center;
}
.required {
  color: red;
  font-size: 0.8rem;
}
hr {
  background-color: black;
}

.invalid-feedback {
  display: block;
}

.printButton {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  border: none;
  background-color: white;
  color: #2b58b8;
  font-weight: bold;
  padding: 5px 5px 5px 5px;
}

@media screen and (max-width: 702px) {
  .printButton {
    width: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    border: none;
    background-color: white;
    color: #006ffa;
    font-weight: bold;
    padding: 5px 5px 5px 5px;
  }

  #broadband-label {
    max-width: 300px;
  }
}
</style>
